import { Button, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLangContext } from "../context/langContext";
import { routerPaths } from "../constants/Paths";

const msg404 = {
  fa: "صفحه مورد نظر پیدا نشد.",
  en: "The page didn't find.",
};

const buttons404 = {
  fa: {
    buttonTextDashboard: "داشبورد",
    buttonTextBroadcasting: "ایجاد پیام صوتی",
  },
  en: {
    buttonTextDashboard: "داشبورد",
    buttonTextBroadcasting: "ایجاد پیام صوتی",
  },
};

export default function NotAccessPage() {
  const navigate = useNavigate();
  const { lang } = useLangContext();

  const buttons = buttons404[lang];

  useEffect(() => {
    navigate("/403");
  }, []);
  return (
    <Stack
      width="100%"
      height="100vh"
      justifyContent="center"
      alignItems="center"
      gap={"12px"}
    >
      <Typography
        variant="d1DemiBold"
        color={(theme) => theme.palette.complement[300]}
      >
        403
      </Typography>
      <Typography variant="h3DemiBold">
        شما به این صفحه دسترسی ندارید.
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={"20px"}
        mt="24px"
      >
        <Button
          component={Link}
          to={routerPaths.DASHBOARD}
          variant={"contained"}
          sx={{
            py: "8px",
            px: "22px",
            textDecoration: "none",
          }}
        >
          <Typography variant="footerDemiBold">
            {buttons.buttonTextDashboard}
          </Typography>
        </Button>
        <Button
          component={Link}
          to={`/${routerPaths.VOICE_BROADCASTS}/create`}
          variant={"activeText"}
          sx={{
            py: "8px",
            px: "22px",
            textDecoration: "none",
          }}
        >
          <Typography variant="footerDemiBold">
            {buttons.buttonTextBroadcasting}
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
}
